import { call, put, takeLatest, fork, all, } from 'redux-saga/effects';
import * as Types from '../constants/Types';
import { sagaWrapper, sagaErrorHandler } from '../helpers/functions';
// import * as GeneralService from './../services/generalService';
import i18n from '../constants/initLng';
import * as SettingActions from './../actions/settingAction';
import { setContentLanguage } from '../utils/commonUtils';

function* changeContentLanguage() {
    yield takeLatest(Types.CONTENT_LANGUAGE_CHANGE_ACTION, sagaWrapper(function* (action) {
        yield setContentLanguage(action.language);
        yield put({type: Types.CONTENT_LANGUAGE_CHANGE_SUCCESS, language: action.language })
    }, errorHandleSetting(Types.SETTING_FAIL)))
}

function errorHandleSetting(errorActionType) {
    return sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'setting');
}


export function* settingSaga() {
    yield all([
        fork(changeContentLanguage),
    ])
}
